import { Button, Card, EditIcon, Pane, TrashIcon } from 'evergreen-ui';
import React, { useState } from 'react';

const lightboxOverlayStyle = {
    position: 'fixed',
    top: 0, left: 0, right: 0, bottom: 0,
    backgroundColor: 'rgba(0,0,0,0.75)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: 99999,
    cursor: 'zoom-out',
};

const lightboxImgStyle = {
    maxWidth: '90vw',
    maxHeight: '90vh',
    objectFit: 'contain',
    borderRadius: 4,
    boxShadow: '0 4px 24px rgba(0,0,0,0.5)',
};

const KImageComponent = (props) => {
    const [showPreview, setShowPreview] = useState(false);
    const fullSrc = props.fullImage || props.image;

    return (
        <Card margin={12}>
            <Pane>
                <img
                    alt="component"
                    src={props.image}
                    style={{ height: '100px', cursor: 'zoom-in' }}
                    onClick={() => setShowPreview(true)}
                />
            </Pane>
            {!props.isView ? <Pane display="flex" gap={10} marginTop={10}>
                <Button type="button" appearance="primary" intent="danger" width="100%" onClick={props.onRemove}>
                    <TrashIcon/>
                </Button>

                 <Button type="button" appearance="primary" width="100%" onClick={props.onEdit}>
                    <EditIcon/>
                </Button>
            </Pane> : null}

            {showPreview && (
                <div style={lightboxOverlayStyle} onClick={() => setShowPreview(false)}>
                    <img alt="preview" src={fullSrc} style={lightboxImgStyle} />
                </div>
            )}
        </Card>
    );
};

export default KImageComponent;
